import styles from '@/styles/breadCrum.module.scss'
import Link from 'next/link'
import { RightOutlined } from '@ant-design/icons'

interface BreadcrumbItem {
  name: string,
  url: string,
  current: boolean
}

interface Props {
  BreadList: BreadcrumbItem[] | []
}

export default function BreadCrum({ BreadList } : Props) {
  return (
    <div className={styles['breadcrum-box']}>
      {
        !!(BreadList && BreadList.length) &&
        <>
          <div key={'anyway'}>
            <Link href={'/'} legacyBehavior>
              <a className={styles['breadcrum-item']} rel="noopener noreferrer">
                Online Shopping
              </a>
            </Link>
            <RightOutlined className={styles['breadcrum-separator']}></RightOutlined>
          </div>
          {
            BreadList.map((item: BreadcrumbItem, index: number) => (
              <div key={index}>
                <Link href={item.url} legacyBehavior>
                  <a className={`${styles['breadcrum-item']} ${ item.current && styles['active-item'] }`} rel="noopener noreferrer">
                    {item.name}
                  </a>
                </Link>
                {index < BreadList.length - 1 && (
                  <RightOutlined className={styles['breadcrum-separator']}></RightOutlined>
                )}
              </div>
            ))
          }
        </>
      }
    </div>
  )
}